import React from 'react';

function renderTilesBlock(data, index) {
  return (
    <section
      key={index}
      className={`tiles tiles-columns-${data.COLUMNS_COUNT}`}
      style={{ backgroundColor: data.BACKGROUND_COLOR }}
    >
      <div className={'container'}>
        {data.CONTENT.map((item, i) => {
          return (
            <div
              key={i}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          );
        })}
      </div>
    </section>
  );
}

export default renderTilesBlock;